<template>
  <div class="survey-question-radio">
    <label
      v-for="option in question.options"
      :key="option"
      class="survey-question-radio__label"
    >
      <SurveyRadio
        :checked="modelValue === option"
        :name="`question-${question.id}`"
        :value="option"
        :on-change="onChange"
      />
      <span class="survey-question-radio__text">{{ option }}</span>
    </label>
  </div>
</template>

<script>
import SurveyRadio from "@/views/Components/Atoms/TicketStore/Survey/SurveyRadio.vue";

export default {
  name: "SurveyQuestionRadio",
  components: { SurveyRadio },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    question: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_survey.scss";

.survey-question-radio {
  @extend %survey-question-option-list;
  padding-left: 20px;

  &__label {
    @extend %survey-question-option-list__label;
  }
}
</style>
